import { styled } from '@mui/material/styles';

/**
 * A plain <img> whose width and height reach the HTML.
 *
 * Use this for every image, never <Box component="img">. MUI's Box treats
 * `width` and `height` as styling shorthand and turns them into CSS, so the
 * attributes silently never render. Without the attributes the browser cannot
 * reserve the image's space before it loads — the page shifts as photos
 * arrive, and PageSpeed flags every image on the site ("Image elements do not
 * have explicit width and height"), which is exactly what happened here.
 *
 * styled('img') forwards unknown props to the element, so
 * <Img width={700} height={933} sx={...}/> produces real attributes AND still
 * accepts sx. The CSS (width: 100%, height: auto) keeps the attributes acting
 * as an aspect-ratio reservation rather than a fixed size.
 */
const Img = styled('img')({ display: 'block' });

export default Img;
